import * as React from 'react';
import { useSelector } from 'react-redux';
import {
	Route,
	RouteProps,
	useHistory,
} from 'react-router-dom';

import { ApplicationState } from '@app/store';
import { Permission } from '@app/objects/Permission';
import { UserPermission, UserRole } from '@app/objects/User';

interface OwnProps extends RouteProps {
	redirectPath?: string;
	permissions: Array<Permission>;
}

function hasPermission(userPermissions: Array<UserPermission>, permission: Permission): boolean {
	return userPermissions.some((userPermission: UserPermission) => permission === userPermission.permission);
}

function userSatisfiesPermissions(userPermissions: Array<UserPermission>, routePermissions: Array<Permission>): boolean {
	return routePermissions.every((routePermission: Permission) => hasPermission(userPermissions, routePermission));
}

export const PermissionRoute: React.FC<OwnProps> = ({
	component: Component,
	redirectPath = '/dashboard',
	permissions,
	...rest
}) => {
	const history = useHistory();
	const user = useSelector((state: ApplicationState) => state.login.user);

	const hasPermission = userSatisfiesPermissions(user?.permissions ?? [], permissions) || user?.role === UserRole.Admin;

	if (!hasPermission) {
		history.replace(redirectPath);
	}

	return (
		<Route
			{...rest}
			component={Component}
		/>
	);
};
